module.exports = __webpack_public_path__ + "img/freezer.c9fb553d.png";